var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultBusiness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.667 109.5H114.583V116.583H121.667M121.667 95.3333H114.583V102.417H121.667M128.75 123.667H100.417V116.583H107.5V109.5H100.417V102.417H107.5V95.3333H100.417V88.25H128.75M93.3333 81.1667H86.25V74.0833H93.3333M93.3333 95.3333H86.25V88.25H93.3333M93.3333 109.5H86.25V102.417H93.3333M93.3333 123.667H86.25V116.583H93.3333M79.1667 81.1667H72.0833V74.0833H79.1667M79.1667 95.3333H72.0833V88.25H79.1667M79.1667 109.5H72.0833V102.417H79.1667M79.1667 123.667H72.0833V116.583H79.1667M100.417 81.1667V67H65V130.75H135.833V81.1667H100.417Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultBusiness);
export default __webpack_public_path__ + "static/media/defaultBusiness.6896e36adcd9b33bc3b2dc250083cb1e.svg";
export { ForwardRef as ReactComponent };